import { useMutation } from "@tanstack/react-query";
import { usePost } from "../api-service";
import { siginResponseModel } from "../../main/signin-page/api/types";
import { resetStorage } from "./auth-service";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "./store";

export const useRefreshToken = () => {
  const { post } = usePost();
  const navigate = useNavigate();
  const authStore = useAuthStore();

  return useMutation({
    mutationFn: async (refreshToken: string) => {
      try {
        authStore.setIsRefreshing(true);
        return await post<object, siginResponseModel>(
          "/api/user/refresh-token",
          {
            refreshToken: refreshToken,
          },
          false
        );
      } catch (error: any) {
        if (error?.response?.data) {
          throw new Error(error.response.data);
        }
        throw new Error("An unexpected error occurred");
      }
    },
    onSuccess: (newData: siginResponseModel) => {
      authStore.setIsRefreshing(false);

      //setAuthData(newData);
      console.log("Token refreshed successfully");

      setTimeout(() => {
        if (authStore.lastFailedRoute) {
          navigate(authStore.lastFailedRoute, { replace: true });
        }
      }, 2000); // 2000 milliseconds = 2 seconds
      return newData;

      //window.location.reload();
    },
    onError: (error: any) => {
      authStore.setIsRefreshing(false);

      resetStorage();
      navigate("/login", { replace: true });
      return error;
    },
  });
};

export const useValidate = () => {
  const { post } = usePost();
  return useMutation<string, Error>({
    mutationFn: () =>
      post<undefined, string>(`/api/auth/validate`, undefined, false),
  });
};
